import React  from "react";
import { useParams } from "react-router-dom";
import PurchaseOrderForm from "./components/PurchaseOrderForm";

const ViewLeave = () => {
	const { orderId } = useParams();
	
	return (
	  <PurchaseOrderForm
			recordId={orderId}
			mode="view"
		/>
    );
};

export default ViewLeave;